import React, { useState, useEffect, useContext, useRef } from 'react';
import { ChevronLeft } from 'react-bootstrap-icons';
import { Button } from 'react-bootstrap';
import _ from 'lodash';

import AppContext from '../../context';
import { fetchImportSummarySmallcase } from '../../../api';
import ImportSummary from './import_summary.component';
import UnrecognisedSymbols from './unrecognised_symbols.component';
import UnsupportedSymbols from './unsupported_symbols.component';
import UnsupportedT1Symbols from './t+1_symbols.component';
import Error from './error.component';
import './broker_connect.component.css';

const BrokerConnect = (props) => {
  const context = useContext(AppContext);
  const { pfId, setStep, onClose, setContext } = props;

  const [summary, setSummary] = useState(null);
  const [showSummary, setShowSummary] = useState(true);
  const [showUnrecognised, setShowUnrecognised] = useState(false);
  const [showUnsupported, setShowUnsupported] = useState(false);
  const [showTplusone, setShowTplusone] = useState(false);
  const [counts, setCounts] = useState(null);
  const [showError, setShowError] = useState(false);

  //to filter t+1 data from original data unsupported array and to create new key with T+1 data along with
  //updated unsupported array with data set that does not have t+1 objects anymore.

  function moveAndFilterTplusoneData(data) {
    const unsupported = [];
    const tplusone = [];
    const valid = [];
    if (data.unsupported && data.unsupported.length) {
      data.unsupported.forEach((obj) =>
        obj.is_tplusoneholding > 0 ? tplusone.push(obj) : unsupported.push(obj),
      );
    }
    if (data.valid && data.valid.length) {
      data.valid.forEach((obj) =>
        obj.is_tplusoneholding > 0 ? tplusone.push(obj) : valid.push(obj),
      );
    }
    data['unsupported'] = unsupported;
    data['tplusone'] = tplusone;
    setSummary(data);
  }

  const fetchHoldings = async () => {
    try {
      const holdings = await fetchImportSummarySmallcase(pfId);
      moveAndFilterTplusoneData(holdings.data.data);
    } catch (error) {
      setShowError(true);
    }
  };

  useEffect(() => {
    fetchHoldings();
  }, []);

  useEffect(() => {
    if (!summary) {
      setCounts(null);
      return;
    }

    const _counts = {
      valid: {
        count: summary.valid.length,
      },
      unrecognised: {
        count: summary.unrecognised.length,
      },
      unsupported: {
        count: summary.unsupported.length,
      },
      tplusone: {
        count: summary.tplusone.length,
      },
    };
    const setSyncedCount = (type) => {
      const syncedCount = summary[type].filter(
        (_datum) => _datum.timestamp === summary.timestamp,
      ).length;
      _counts[type].count = _counts[type].count - syncedCount;
      _counts[type].synced_count = syncedCount;
    };
    setSyncedCount('valid');
    _counts.unrecognised.count && setSyncedCount('unrecognised');
    _counts.unsupported.count && setSyncedCount('unsupported');
    _counts.tplusone.count && setSyncedCount('tplusone');
    setCounts(_counts);
  }, [summary]);

  // useEffect(() => {
  //   if (counts) {
  //     props.setShowImportSummary(true);
  //   }
  // }, [counts]);

  return summary && counts ? (
    <>
      <section className="add-tx-content p-md-5">
        <div className="add-tx-header position-relative p-md-0 p-3">
          <span className="step-text">{context.portfoliosById[pfId].name}</span>
          <h5 className="step-heading pt-1">REVIEW IMPORT SUMMARY</h5>
        </div>
        <ImportSummary
          pfId={pfId}
          counts={counts}
          summary={summary}
          setSummary={setSummary}
          show={showSummary}
          setShow={setShowSummary}
          setShowUnrecognised={setShowUnrecognised}
          setShowUnsupported={setShowUnsupported}
          setShowTplusone={setShowTplusone}
        />
        <UnrecognisedSymbols
          data={summary.unrecognised}
          timestamp={summary.timestamp}
          show={showUnrecognised}
          setShow={setShowUnrecognised}
          setShowImportSummary={setShowSummary}
        />
        <UnsupportedSymbols
          data={summary.unsupported}
          timestamp={summary.timestamp}
          show={showUnsupported}
          setShow={setShowUnsupported}
          setShowImportSummary={setShowSummary}
        />
        <UnsupportedT1Symbols
          data={summary.tplusone}
          timestamp={summary.timestamp}
          show={showTplusone}
          setShow={setShowTplusone}
          setShowImportSummary={setShowSummary}
        />
      </section>
      <div className="modal-footer">
        {!props.emptyPfs && (
          <button
            type="button"
            className="mr-auto back-button btn btn-sm"
            onClick={() => {
              if (props.isWebview) {
                window.Android.goBack();
                return;
              }
              setStep('manage_two');
            }}
          >
            <ChevronLeft /> <span>back</span>
          </button>
        )}
        <Button
          size="sm"
          onClick={() => {
            if (props.isWebview) {
              window.Android.goBack();
              return;
            }
            onClose();
          }}
          variant="success"
          className="modal-btn save close-btn"
        >
          Close
        </Button>
      </div>
    </>
  ) : (
    <Error
      show={showError}
      setShow={setShowError}
      onRetry={fetchHoldings}
      text="Could not fetch import summary"
    />
  );
};

export default BrokerConnect;
